var map = {
	"./app.module": [
		"./src2/app/app.module.ts"
	],
	"./arena.module": [
		"./src2/app/arena.module/index.ts"
	],
	"./arena.module/arena.module": [
		"./src2/app/arena.module/arena.module.ts"
	],
	"./auth.module": [
		"./src2/app/auth.module/index.ts"
	],
	"./auth.module/auth.module": [
		"./src2/app/auth.module/auth.module.ts"
	],
	"./core/core.module": [
		"./src2/app/core/core.module.ts"
	],
	"./dlg-decoration.module": [
		"./src2/app/dlg-decoration.module/index.ts"
	],
	"./dlg-decoration.module/dlg-decoration.module": [
		"./src2/app/dlg-decoration.module/dlg-decoration.module.ts"
	],
	"./enter.module": [
		"./src2/app/enter.module/index.ts",
		6,
		7
	],
	"./enter.module/enter.module": [
		"./src2/app/enter.module/enter.module.ts",
		6
	],
	"./enter2.module": [
		"./src2/app/enter2.module/index.ts"
	],
	"./enter2.module/enter2.module": [
		"./src2/app/enter2.module/enter2.module.ts"
	],
	"./gallery.module": [
		"./src2/app/gallery.module/index.ts",
		0,
		8
	],
	"./gallery.module/gallery.module": [
		"./src2/app/gallery.module/gallery.module.ts",
		0
	],
	"./inventory.module": [
		"./src2/app/inventory.module/index.ts",
		5,
		9
	],
	"./inventory.module/inventory.module": [
		"./src2/app/inventory.module/inventory.module.ts",
		5
	],
	"./market.module": [
		"./src2/app/market.module/index.ts"
	],
	"./market.module/market.module": [
		"./src2/app/market.module/market.module.ts"
	],
	"./menu.module": [
		"./src2/app/menu.module/index.ts"
	],
	"./menu.module/menu.module": [
		"./src2/app/menu.module/menu.module.ts"
	],
	"./nw-menu.module": [
		"./src2/app/nw-menu.module/index.ts"
	],
	"./nw-menu.module/nw-menu.module": [
		"./src2/app/nw-menu.module/nw-menu.module.ts"
	],
	"./power.module": [
		"./src2/app/power.module/index.ts"
	],
	"./power.module/power.module": [
		"./src2/app/power.module/power.module.ts"
	],
	"./profile.module": [
		"./src2/app/profile.module/index.ts"
	],
	"./profile.module/propfile.module": [
		"./src2/app/profile.module/propfile.module.ts"
	],
	"./season-world-landing.module": [
		"./src2/app/season-world-landing.module/index.ts"
	],
	"./season-world-landing.module/season-world-landing.module": [
		"./src2/app/season-world-landing.module/season-world-landing.module.ts"
	],
	"./seasons-archive.module": [
		"./src2/app/seasons-archive.module/index.ts",
		0,
		1,
		4,
		"common"
	],
	"./seasons-archive.module/seasons-archive.module": [
		"./src2/app/seasons-archive.module/seasons-archive.module.ts",
		0,
		1,
		4
	],
	"./seasons-chronicle.module": [
		"./src2/app/seasons-chronicle.module/index.ts",
		0,
		1,
		2,
		3,
		"common"
	],
	"./seasons-chronicle.module/seasons-chronicle.module": [
		"./src2/app/seasons-chronicle.module/seasons-chronicle.module.ts",
		0,
		1,
		2,
		3
	],
	"./seasons-rating.module": [
		"./src2/app/seasons-rating.module/index.ts",
		0,
		1,
		2,
		"common"
	],
	"./seasons-rating.module/seasons-rating.module": [
		"./src2/app/seasons-rating.module/seasons-rating.module.ts",
		0,
		1,
		2,
		"common"
	],
	"./seasons.module": [
		"./src2/app/seasons.module/index.ts",
		0,
		1,
		10
	],
	"./seasons.module/seasons.module": [
		"./src2/app/seasons.module/seasons.module.ts",
		0,
		1
	],
	"./shards.module": [
		"./src2/app/shards.module/index.ts"
	],
	"./shards.module/shards.module": [
		"./src2/app/shards.module/shards.module.ts"
	],
	"./shared-dialogs.module": [
		"./src2/app/shared-dialogs.module/index.ts"
	],
	"./shared-dialogs.module/shared-dialogs.module": [
		"./src2/app/shared-dialogs.module/shared-dialogs.module.ts"
	],
	"./shared-services.module": [
		"./src2/app/shared-services.module/index.ts"
	],
	"./shared-services.module/shared-services.module": [
		"./src2/app/shared-services.module/shared-services.module.ts"
	],
	"./shared/shared.module": [
		"./src2/app/shared/shared.module.ts"
	],
	"./simulation-mode.module": [
		"./src2/app/simulation-mode.module/index.ts"
	],
	"./simulation-mode.module/simulation-mode.module": [
		"./src2/app/simulation-mode.module/simulation-mode.module.ts"
	],
	"./steam-news.module": [
		"./src2/app/steam-news.module/index.ts"
	],
	"./steam-news.module/steam-news.module": [
		"./src2/app/steam-news.module/steam-news.module.ts"
	],
	"./toastr.module": [
		"./src2/app/toastr.module/index.ts"
	],
	"./toastr.module/toastr.module": [
		"./src2/app/toastr.module/toastr.module.ts"
	],
	"./ui.module": [
		"./src2/app/ui.module/index.ts"
	],
	"./ui.module/ui.module": [
		"./src2/app/ui.module/ui.module.ts"
	],
	"./world-map.module": [
		"./src2/app/world-map.module/index.ts"
	],
	"./world-map.module/world-map.module": [
		"./src2/app/world-map.module/world-map.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src2/app lazy recursive ^\\.\\/.*\\.module$";
module.exports = webpackAsyncContext;